export default "__VITE_ASSET__Dp6VYk4c__"